import { StyleSheet, View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'
import { FC, ReactNode } from 'react'

interface OwnProps {
  children: ReactNode
  borderLeft?: boolean
  borderRight?: boolean
  borderTop?: boolean
  borderBottom?: boolean
  size?: number
  style?: Style
  debug?: boolean
}

const Col: FC<OwnProps> = (props: OwnProps) => {
  const styles = StyleSheet.create({
    col: {
      flexGrow: props.size || 1,
      borderLeftWidth: props.borderLeft ? 0.5 : 0,
      borderRightWidth: props.borderRight ? 0.5 : 0,
      borderTopWidth: props.borderTop ? 0.5 : 0,
      borderBottomWidth: props.borderBottom ? 0.5 : 0,
      ...props.style,
    },
  })
  return (
    <View style={styles.col} debug={props.debug ?? false}>
      {props.children}
    </View>
  )
}

export default Col
